// extracted by mini-css-extract-plugin
export default {"importCsvCard":"AddDesignation_importCsvCard__rchGn","addDesignationBtnContainer":"AddDesignation_addDesignationBtnContainer__T39px"};